/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_DetailsInputs */

const en_job_details = /** @type {(inputs: Job_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Details`)
};

const de_job_details = /** @type {(inputs: Job_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobdetails`)
};

/**
* | output |
* | --- |
* | "Job Details" |
*
* @param {Job_DetailsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_details = /** @type {((inputs?: Job_DetailsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_DetailsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_details(inputs)
	return en_job_details(inputs)
});